import type { MediaMetadata } from '@/types/storage'
import { mediaLibraryService } from '@/features/media-library/services/media-library-service'
import {
  aliyunTtsService,
  type AliyunTtsLanguage,
} from '@/features/voiceover/services/aliyun-tts-service'

export type AssistantTtsEngine = 'aliyun'

export type GenerateTtsAudioRequest = {
  engine: 'aliyun'
  text: string
  voice: string
  languageType?: AliyunTtsLanguage
  onProgress?: (stage: string) => void
}

export async function generateTtsAudio(request: GenerateTtsAudioRequest): Promise<{
  blob: Blob
  file: File
  duration: number
  engine: AssistantTtsEngine
}> {
  const result = await aliyunTtsService.generateSpeechFile({
    text: request.text,
    voice: request.voice,
    languageType: request.languageType ?? 'Chinese',
    onProgress: request.onProgress,
  })
  return { ...result, engine: 'aliyun' }
}

export async function saveGeneratedAudioToProjectMedia(
  file: File,
  projectId: string,
  options?: {
    tags?: string[]
    codec?: string
  },
): Promise<MediaMetadata> {
  return mediaLibraryService.importGeneratedAudio(file, projectId, {
    tags: options?.tags,
    codec: options?.codec,
  })
}
